// Tracks only the initial request wave. It never starts/cancels network requests.
export default function createPageLoadTracker() {
  let phase = 'waiting'
  let pending = 0
  let mounted = false
  let started = false
  let disposed = false
  let shownAt = 0
  let showTimer
  let settleTimer
  const listeners = new Set()
  const active = () => !disposed && phase !== 'ready'
  const emit = () => listeners.forEach((listener) => listener(phase))
  const settle = () => {
    clearTimeout(settleTimer)
    if (!started || !active() || !mounted || pending) return
    // Allow effects triggered by response state to register dependent requests.
    settleTimer = setTimeout(() => {
      if (!active() || pending) return
      const remaining = shownAt ? Math.max(0, 350 - (Date.now() - shownAt)) : 0
      settleTimer = setTimeout(() => {
        if (!active() || pending) return
        clearTimeout(showTimer)
        phase = 'ready'
        emit()
      }, remaining)
    }, 32)
  }
  return {
    subscribe(listener) {
      listeners.add(listener)
      listener(phase)
      return () => listeners.delete(listener)
    },
    start() {
      started = true
      showTimer = setTimeout(() => {
        if (!active()) return
        shownAt = Date.now()
        phase = 'skeleton'
        emit()
      }, 150)
      settle()
    },
    mounted() {
      mounted = true
      settle()
    },
    begin() {
      if (!active()) return () => {}
      pending++
      clearTimeout(settleTimer)
      let finished = false
      return () => {
        if (finished || disposed) return
        finished = true
        pending--
        settle()
      }
    },
    dispose() {
      disposed = true
      clearTimeout(showTimer)
      clearTimeout(settleTimer)
      listeners.clear()
    }
  }
}
